import { call, delay, put, select, take } from 'redux-saga/effects';

import {
	actions as currentNotificationActions,
	selectors as currentNotificationSelectors,
} from 'modules/api/notifications/currentModule';
import {
	hasAuthToken as getHasAuthToken,
	isBasketAdmin as getIsBasketAdmin,
} from 'modules/auth/authSelectors';

const POLL_SECONDS = 30;
const UNIQ_POLL_SECONDS = 5;

function* fetchCurrentNotifications() {
	const hasAuthToken = yield select(getHasAuthToken);
	const isBasketAdmin = yield select(getIsBasketAdmin);
	if (hasAuthToken && !isBasketAdmin) {
		yield put(currentNotificationActions.fetch());
	}
}

export function* waitForUniqId(action) {
	yield fetchCurrentNotifications();
	yield take(currentNotificationActions.setType);
	let notifications = yield select(currentNotificationSelectors.newestPerAsset);

	let notification = notifications.find(
		(x) =>
			x.get('uniq_id') === action.uniqId &&
			x.get('category') === action.category,
	);
	while (notification) {
		yield fetchCurrentNotifications();
		yield delay(UNIQ_POLL_SECONDS * 1000);
		yield take(currentNotificationActions.setType);
		notifications = yield select(currentNotificationSelectors.newestPerAsset);
		notification = notifications.find(
			(x) =>
				x.get('uniq_id') === action.uniqId &&
				x.get('category') === action.category,
		);
	}
	if (action.toFetchAfter) {
		yield call(action.toFetchAfter);
	}
}

export default function* saga() {
	// We are polling like this since the fetchAndPoll method stops upon navigation.
	while (true) {
		yield fetchCurrentNotifications();
		yield delay(POLL_SECONDS * 1000);
	}
}
